export default __webpack_public_path__ + "static/media/go-to-market.6412825d.svg";